module.exports = __webpack_public_path__ + "08349fd5aeb03d02300896ffafdc0090.pdf";